const status_sfr = [
  '0.Bloquée/Suspendu MAD',
  '0.Bloquée/Suspendu Conv',
  '0.Bloquée/Suspendu DP',
  '1.En Recherche',
  '2.En validation',
  '3.Validé',
  '3.En Conception',
  '4.En cours conception',
  '4.GO Constr. Anticipé',
  '5.En attente visées FH',
  '5.GO Constructibilité',
  '6.GO Constructibilité',
  '6.Mad Infra',
  '7.GO Constructibilité Anticipé',
  '7.MES',
  '8.Annulé',
  '8.PEM',
  'En service',
];
const ops = ['SFR', 'ORANGE', 'FREE', 'Bouygues Telecom'];
const regions = [
  'Auvergne-Rhône-Alpes',
  'Bourgogne-Franche-Comté',
  'Bretagne',
  'Centre-Val de Loire',
  'Corse',
  'Grand-Est',
  'Guadeloupe',
  'Guyane',
  'Hauts-de-France',
  'Île-de-France',
  'Martinique',
  'Normandie',
  'Nouvelle-Aquitaine',
  'Occitanie',
  'Pays de la Loire',
  'Provence-Alpes-Cote-dAzur',
];
const program = [
  '4GFixe',
  'DCC',
  'ARP',
  'DENSIF_CZ_RED',
  'DENSIF_CZ',
  'ZTD_RED',
  'PAC-REMP',
  'PAC',
  'PAC-DUP',
  'PAC-CONTINUITY-PLAN',
  'FM',
  'ORF',
  'SFR TT',
  'FM TT',
];
const Status_Site = ['Activé', 'Inactif', 'Terminé'];
export { status_sfr, ops, regions, program, Status_Site };
